import { shallowEqual, useSelector } from 'react-redux'

import { PageId } from 'routing/pages'
import { selectDenormalizedTabs, selectDenormalizedTabById } from 'selectors/ui'
import { RootReduxState, DashboardTab } from 'types'

export function useDenormalizedTabs<T = DashboardTab[]>(page: PageId): T {
    return useSelector<RootReduxState, T>(
        (state) => selectDenormalizedTabs(state, page),
        shallowEqual
    )
}

export function useDenormalizedTabById<T = DashboardTab>(
    page: PageId,
    tabId?: string
): T | null {
    return useSelector<RootReduxState, T>(
        (state) => selectDenormalizedTabById(state, page, tabId),
        shallowEqual
    )
}
